export default __webpack_public_path__ + "static/assets/images/case-study/case-study-colored.8f5599c91e8bb6fbfce953d2cb947e7c.svg";